<template>
  <div ref="root" class="navbar-item language-selector">
    <button
      class="language-trigger"
      type="button"
      aria-haspopup="true"
      :aria-expanded="isOpen.toString()"
      @click.stop="toggleDropdown"
    >
      <span class="language-icon" aria-hidden="true">🌐</span>
      <span class="language-label">{{ currentLocaleLabel }}</span>
      <span class="language-caret" aria-hidden="true">▾</span>
    </button>

    <transition name="language-dropdown">
      <div v-if="isOpen" class="language-menu" role="menu">
        <button
          v-for="l in selectableLocales"
          :key="l.locale"
          class="language-option"
          type="button"
          role="menuitemradio"
          :aria-checked="l.locale === locale ? 'true' : 'false'"
          @click.stop="selectLocale(l.locale)"
        >
          {{ l.label }}
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

const availableLocales = [
  { locale: "es", label: "Español" },
  { locale: "en", label: "English" },
  { locale: "zh", label: "中文" },
  { locale: "de", label: "Deutsch" },
  { locale: "pt", label: "Português" },
  { locale: "fr", label: "Français" },
];

export default {
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    ...mapGetters(["locale"]),
    currentLocaleLabel() {
      const current = availableLocales.find((l) => l.locale === this.locale);
      return current ? current.label : this.locale;
    },
    selectableLocales() {
      return availableLocales.filter((l) => l.locale !== this.locale);
    },
  },
  mounted() {
    document.addEventListener("click", this.onClickOutside);
    document.addEventListener("keydown", this.onKeyDown);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.onClickOutside);
    document.removeEventListener("keydown", this.onKeyDown);
  },
  methods: {
    ...mapActions(["setLocale"]),
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    selectLocale(nextLocale) {
      this.setLocale(nextLocale);
      this.isOpen = false;
    },
    onClickOutside(event) {
      if (!this.$refs.root || !this.$refs.root.contains(event.target)) {
        this.isOpen = false;
      }
    },
    onKeyDown(event) {
      if (event.key === "Escape") {
        this.isOpen = false;
      }
    },
  },
};
</script>

<style scoped>
.language-selector {
  position: relative;
  padding-left: 0.75rem;
  margin-left: 0.5rem;
  border-left: 1px solid rgba(255, 255, 255, 0.2);
}

.language-trigger {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  border: 0;
  background: transparent;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.92rem;
  line-height: 1;
  border-radius: 6px;
  padding: 0.4rem 0.55rem;
  cursor: pointer;
  transition: background-color 0.18s ease;
}

.language-trigger:hover,
.language-trigger:focus-visible {
  background: rgba(255, 255, 255, 0.12);
  outline: none;
}

.language-caret {
  font-size: 0.75em;
}

.language-menu {
  position: absolute;
  right: 0;
  top: calc(100% + 0.35rem);
  min-width: 9rem;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);
  padding: 0.35rem;
  z-index: 30;
}

.language-option {
  width: 100%;
  text-align: left;
  border: 0;
  background: transparent;
  border-radius: 6px;
  padding: 0.45rem 0.55rem;
  font-size: 0.9rem;
  color: #363636;
  cursor: pointer;
}

.language-option:hover,
.language-option:focus-visible {
  background: #f5f5f5;
  outline: none;
}

.language-dropdown-enter-active,
.language-dropdown-leave-active {
  transition:
    opacity 0.16s ease,
    transform 0.16s ease;
}

.language-dropdown-enter,
.language-dropdown-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

@media (max-width: 1023px) {
  .language-selector {
    width: 100%;
    margin: 0.25rem 0 0;
    padding: 0.55rem 0.25rem 0.2rem;
    border-left: 0;
    border-top: 1px solid rgba(255, 255, 255, 0.16);
  }

  .language-menu {
    left: 0;
    right: auto;
    min-width: 12rem;
  }
}
</style>
